import { Component } from '@angular/core';

@Component({
  selector: 'app-workshop-jobcard-customer-search-skeleton-loader',
  templateUrl: './workshop-jobcard-customer-search-skeleton-loader.component.html',
  styleUrls: ['./workshop-jobcard-customer-search-skeleton-loader.component.scss']
})
export class WorkshopJobcardCustomerSearchSkeletonLoaderComponent {

  skeletonItems = Array(2).fill(0); // Shows 5 skeleton items
}
